import { CoinbaseWallet } from '@web3-react/coinbase-wallet';
import { initializeConnector } from '@web3-react/core';
import { NETWORK_CHAIN_ID } from '@/constants';
import { URLS } from './chains';

export const [coinbaseWallet, hooks] = initializeConnector<CoinbaseWallet>(
  (actions) =>
    new CoinbaseWallet({
      actions,
      options: {
        url: URLS[NETWORK_CHAIN_ID][0],
        appName: 'web3-react',
      },
    })
);
